// These are the translation keys - the actual values are in the translation files
export const cuisineKeys = [
  "Danish",
  "Italian",
  "Chinese",
  "Thai",
  "Indian",
  "French",
  "Japanese",
  "Mexican",
  "Greek",
  "Spanish",
  "American",
  "Korean",
  "Turkish",
  "Lebanese",
  "British",
  "German",
  "Portuguese",
  "Swedish",
  "Norwegian",
  "Irish",
  "Scottish",
  "Welsh",
  "Brazilian",
  "Argentinian",
  "Colombian",
  "Jamaican",
  "Andet",
];

export const mealTypeKeys = [
  "Morgenmad",
  "Frokost",
  "Aftensmad",
  "Dessert",
  "Snack",
  "Drikke",
];

// Keep the original exports for backward compatibility and validation
export const cuisines = cuisineKeys;
export const mealsTypes = mealTypeKeys;
